// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"300":"1f4c5124","372":"83e1f221","592":"7267f101","856":"005ecee3","864":"81ec8ef0"}[chunkId] + ".chunk.js";
};